import { FlaskConical } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Loud, consistent marker for sample records. Rendered next to the name of
 * every sample entity (workspaces, tasks, workflows, executions, approvals,
 * integrations) so a user is never uncertain whether a number or row is real.
 */
export function SampleBadge({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center gap-0.5 rounded px-1 py-px text-[9px] font-bold uppercase tracking-wide",
        "bg-amber-400/15 text-amber-500 dark:text-amber-300",
        className,
      )}
      title="Sample data — not a real record"
    >
      <FlaskConical size={8} /> Sample
    </span>
  );
}
